import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en-us.json';
import fr from './fr.json';
import de from './de.json';
import es419 from './es-419.json';
import es from './es.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import pl from './pl.json';
import pt from './pt-br.json';
import ru from './ru.json';
import tr from './tr.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en,
      fr,
      de,
      es419,
      es,
      it,
      ja,
      ko,
      pl,
      pt,
      ru,
      tr,
    },
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
  });
export default i18next;
